
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class RawMaterialMasterDialog extends _Ext.DialogBase<RawMaterialMasterRow, any> {
        protected getFormKey() { return RawMaterialMasterForm.formKey; }
        protected getIdProperty() { return RawMaterialMasterRow.idProperty; }
        protected getLocalTextPrefix() { return RawMaterialMasterRow.localTextPrefix; }
        protected getNameProperty() { return RawMaterialMasterRow.nameProperty; }
        protected getService() { return RawMaterialMasterService.baseUrl; }
        protected getDeletePermission() { return RawMaterialMasterRow.deletePermission; }
        protected getInsertPermission() { return RawMaterialMasterRow.insertPermission; }
        protected getUpdatePermission() { return RawMaterialMasterRow.updatePermission; }
        protected useViewMode() { return true; }
        public isReadOnly = this.isViewMode();


        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;

        }

        protected form = new RawMaterialMasterForm(this.idPrefix);
        constructor() {
            super();
           //his.isReadOnly = this.isViewMode();
            q.hideCategorylinks(this.element);
            q.hideEditorCategory(this.form.StoneCuletId);
            q.setTextRightAlign(this.form.PointerWeight);
            q.setTextRightAlign(this.form.Variance);
            var min = 0, max = 0, std = 0;
            this.form.KaratId.changeSelect2(e => {
                this.form.AttributeId.value = "0";
                var KaratId = Q.toId(this.form.KaratId.value);
                var purity: OMS.AttributeMasterRow;
                OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                    purity = response.Entity
                }, { async: false });
                var min = purity.MinPurity;
                var max = purity.MaxPurity;
                var std = purity.StdPurity;
                this.form.Purity.value = std;

            });

            this.form.Purity.changeSelect2(e => {
                var KaratId = Q.toId(this.form.KaratId.value);
                var purity: OMS.AttributeMasterRow;
                OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                    purity = response.Entity
                }, { async: false });
                var min = purity.MinPurity;
                var max = purity.MaxPurity;
                var std = purity.StdPurity;
                var current = this.form.Purity.value;
                if (current < min || current > max) {
                    Q.alert("Enter Purity between  " + min.toString() + "  to  " + max.toString());
                    this.form.Purity.value = std;
                }
            });

            this.form.ProductCode.changeSelect2(e => {
                try {

                    let PrdId = 0;
                    
                    OMS.ProductMasterService.AllProductsList({ ProductCode: this.form.ProductCode.value.toUpperCase(), Take: 1 },
                        response => {
                            if (response.Entities.length > 0)
                                PrdId = response.Entities[0].ProductId;
                        }, {
                        async: false
                    }
                    );

                    if (PrdId > 0) {
                        Q.notifyError("Duplicate Product Code " + this.form.ProductCode.value);
                        this.form.ProductCode.value = "";
                        this.form.ProductCode.element.focus();
                        return;
                    }
                    else {
                        this.form.ProductCode.value = this.form.ProductCode.value.toUpperCase();
                    }

                }
                catch (undefined) {

                }
            });


            this.form.SieveId.changeSelect2(e => {
                this.form.AttributeId.value = "0";
                var GroupSieve = AttributeMasterRow.getLookup().itemById[this.form.SieveId.value].GroupSieveId;
                this.form.GroupSieveId.value = GroupSieve;

            });

            this.form.ProductTypeId.changeSelect2(e => {
                this.form.AttributeId.value = "0";
                this.Setfields();

                switch (parseInt(this.form.ProductTypeId.value)) {
                    case 11:
                    case 12:
                    case 15:
                        this.form.ItemTypeId.value = '105';
                        this.form.CategoryId.cascadeField = "ItemTypeId";
                        this.form.CategoryId.cascadeValue = "105";
                        q.showAndEnableField(this.form.Rate);
                        q.showAndEnableField(this.form.SalesPrice);
                        q.showAndSetRequiredField(this.form.CostMethodId);
                        break;
                    case 5:
                    case 6:
                    case 7:
                    case 9:
                    case 10:
                        this.form.ItemTypeId.value = '104';
                        this.form.CategoryId.cascadeField = "ItemTypeId";
                        this.form.CategoryId.cascadeValue = "104";
                        this.form.SubCategoryId.value = "0";
                        q.hideField(this.form.Rate);
                        q.hideField(this.form.SalesPrice);
                        q.hideField(this.form.CostMethodId);
                        break;
                }

                //if (this.form.ProductTypeId.value == "11" ) {
                //    this.form.SubCategoryId.cascadeField = "CategoryId";
                //    this.form.SubCategoryId.cascadeValue = "1";
                //    this.form.CategoryId.value = "124";
                //}
                //if (this.form.ProductTypeId.value == "12") {
                //    this.form.SubCategoryId.cascadeField = "CategoryId";
                //    this.form.SubCategoryId.cascadeValue = "125";
                //    this.form.CategoryId.value = "125";
                //}
            });

            this.form.CategoryId.changeSelect2(e => {
                this.form.AttributeId.value = "0";
                this.form.SubCategoryId.CategoryId = parseInt(this.form.CategoryId.value);
                this.form.SubCategoryId.updateItems();

                switch (parseInt(this.form.CategoryId.value)) {
                    case 1 :
                    case 3 :
                    case 4:
                        q.hideField(this.form.StoneCutId, true);
                        q.hideField(this.form.StonePolishId, true);
                        q.hideField(this.form.StoneSymmetryId, true);
                        q.hideField(this.form.StoneFluorescenceId, true);
                        q.hideField(this.form.StoneCuletId, true);
                        q.hideField(this.form.StoneGirdleId, true);
                        q.hideField(this.form.StoneTable, true);
                        q.hideField(this.form.StoneDepth, true);
                        q.hideEditorCategory(this.form.StoneCuletId);
                        this.form.SubCategoryId.cascadeField = "CategoryId";
                        this.form.SubCategoryId.cascadeValue = this.form.CategoryId.value;

                        break;
                    case 2:
                        q.hideCategories(this.element, false);
                        q.showAndSetRequiredField(this.form.StoneCutId);
                        q.showAndSetRequiredField(this.form.StonePolishId);
                        q.showAndSetRequiredField(this.form.StoneSymmetryId);
                        q.showAndSetRequiredField(this.form.StoneFluorescenceId);
                        q.showAndSetRequiredField(this.form.StoneCuletId);
                        q.showAndSetRequiredField(this.form.StoneGirdleId);
                        q.showAndSetRequiredField(this.form.StoneTable);
                        q.showAndSetRequiredField(this.form.StoneDepth);
                        q.hideEditorCategory(this.form.StoneCuletId, false);

                        break;
                    case 5:
                    case 6:
                    case 8:
                        q.hideField(this.form.SubCategoryId)
                        this.form.SubCategoryId.value = "0";
                        break;
                    case 7:
                        q.showAndSetRequiredField(this.form.SubCategoryId);
                }

            });

            this.form.SubCategoryId.changeSelect2(e => {
                this.form.AttributeId.value = "0";
            });

            this.form.StoneColorId.changeSelect2(e => {
                this.form.AttributeId.value = "0";
            });

            this.form.QualityId.changeSelect2(e => {
                this.form.AttributeId.value = "0";
            });

            this.form.ShapeId.changeSelect2(e => {
                this.form.AttributeId.value = "0";
                this.form.StoneSizeId.ShapeId = Q.parseInteger(this.form.ShapeId.value);
                this.form.SieveId.ShapeId = Q.parseInteger(this.form.ShapeId.value);
                this.form.StoneSizeId.updateItems();
                this.form.SieveId.updateItems();
            });

            this.form.StoneSizeId.changeSelect2(e => {
                this.form.AttributeId.value = "0";
                this.form.SieveId.ShapeId = Q.parseInteger(this.form.ShapeId.value);
                this.form.SieveId.SizeId = Q.parseInteger(this.form.StoneSizeId.value);
                this.form.SieveId.updateItems();
            });

            this.form.StoneCuletId.changeSelect2(e => {
                this.form.AttributeId.value = "0";
            });

            this.form.StoneCutId.changeSelect2(e => {
                this.form.AttributeId.value = "0";
            });

            this.form.StoneSymmetryId.changeSelect2(e => {
                this.form.AttributeId.value = "0";
            });

            this.form.StoneFluorescenceId.changeSelect2(e => {
                this.form.AttributeId.value = "0";
            });

            this.form.StoneTable.changeSelect2(e => {
                this.form.AttributeId.value = "0";
            });

            this.form.StoneDepth.changeSelect2(e => {
                this.form.AttributeId.value = "0";
            });

            this.form.Purity.element.css({ "text-align": "right" });

        }



        private Setfields() {

            if (this.form.ProductTypeId.value == "5" || this.form.ProductTypeId.value == "6" || this.form.ProductTypeId.value == "7" || this.form.ProductTypeId.value == "9" || this.form.ProductTypeId.value == "10") {
                q.showAndSetRequiredField(this.form.KaratId);
                q.showAndSetRequiredField(this.form.MetalColorId);
                q.showAndSetRequiredField(this.form.Purity);
                q.showAndSetRequiredField(this.form.ForExchange);

                q.showAndSetRequiredField(this.form.CategoryId);
                q.hideField(this.form.SubCategoryId);
                q.hideField(this.form.ShapeId);
                q.hideField(this.form.QualityId);
                q.hideField(this.form.StoneColorId);
                q.hideField(this.form.StoneSizeId);
                q.hideField(this.form.SieveId);
                q.hideField(this.form.PointerWeight);
                q.hideField(this.form.Variance);
                this.entity.MetalId = parseInt(this.form.ProductTypeId.value);

                if (Q.isEmptyOrNull(this.form.ItemTypeId.value))
                    this.form.ItemTypeId.value = "104";

                if (Q.isEmptyOrNull(this.form.SubCategoryId.value))
                    this.form.SubCategoryId.value = "0";
            }

            if (this.form.ProductTypeId.value == "11" || this.form.ProductTypeId.value == "12" || this.form.ProductTypeId.value == "15") {
                this.isReadOnly ? q.showAndDisableField(this.form.CategoryId):q.showAndSetRequiredField(this.form.CategoryId);
                q.showAndSetRequiredField(this.form.SubCategoryId);
                q.showAndSetRequiredField(this.form.ShapeId);
                q.showAndSetRequiredField(this.form.QualityId);
                q.showAndSetRequiredField(this.form.StoneColorId);
                q.showAndSetRequiredField(this.form.StoneSizeId);
                q.showAndSetRequiredField(this.form.SieveId);
                q.showAndSetRequiredField(this.form.PointerWeight);
                q.showAndSetRequiredField(this.form.Variance);
                q.hideField(this.form.KaratId);
                q.hideField(this.form.MetalColorId);
                q.hideField(this.form.Purity);
                q.hideField(this.form.ForExchange);
                if (this.form.ProductTypeId.value == "11")
                    this.form.StoneSizeId.BaseItem = 11;

                if (Q.isEmptyOrNull(this.form.ItemTypeId.value))
                    this.form.ItemTypeId.value = "105";
            }
        }

        validateBeforeSave() {
            var Isvalid = super.validateBeforeSave();
            var en = this.entity;
            this.form.AttributeId.value = '';
            return Isvalid;
        }


        protected getCloningEntity() {
            var clone = super.getCloningEntity();
            clone.ProductCode = null;
            clone.ProductName = null;
            return clone;
        }


        afterLoadEntity() {
            super.afterLoadEntity();
            if (this.entity.ProductId > 0) {
                Serenity.EditorUtils.setReadOnly(this.form.ProductCode, true);
                this.form.CategoryId.ItemTypeId = this.entity.ItemTypeId;
                this.form.SubCategoryId.CategoryId = this.entity.CategoryId;
                this.form.CategoryId.updateItems();
                this.form.SubCategoryId.updateItems();
            }
            if (Q.parseInteger(this.form.ProductTypeId.value) > 0) {
                this.Setfields();
                switch (parseInt(this.form.ProductTypeId.value)) {
                    case 11:
                    case 12:
                    case 15:
                        //this.form.CategoryId.cascadeField = "ItemTypeId";
                        //this.form.CategoryId.cascadeValue = "105";
                        q.showAndEnableField(this.form.Rate);
                        q.showAndEnableField(this.form.SalesPrice);
                        break;
                    case 5:
                    case 6:
                    case 7:
                    case 9:
                    case 10:
                        if (Q.isEmptyOrNull(this.form.CategoryId.value))
                            this.form.CategoryId.value = "5";
                        if (Q.isEmptyOrNull(this.form.SubCategoryId.value))
                            this.form.SubCategoryId.value = "0";
                        q.hideField(this.form.Rate);
                        q.hideField(this.form.SalesPrice);
                        break;
                }
               
            }

          
        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();
            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");
            var oldDeleteClick = btnDelete.onClick;
            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };
            return btns;
        }


        private confirmBeforeDelete(oldEvt, e) {
            let self = this;

            var criteria: any;
            var BOMRow: OMS.ProductBOMRow;
            var StockRow: Stock.StockItemRow;
            OMS.ProductBOMService.List({
                Criteria: Serenity.Criteria.and(criteria, [[OMS.ProductBOMRow.Fields.BOMProductId], '=', this.entityId])
            }, response => BOMRow = response.Entities[0], { async: false });

            if (BOMRow == null)
            Stock.StockItemService.List({
                Criteria: Serenity.Criteria.and(criteria, [[Stock.StockItemRow.Fields.ProductId], '=', this.entityId])
            }, response => StockRow = response.Entities[0], { async: false });

            if (BOMRow != null && StockRow != null) {
                Q.alert("This Material is already in use in Product, Can not delete");
                return;

            }
            else {

                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.isConfirmed) {
                        RawMaterialMasterService.Delete(
                            {
                                EntityId: this.entityId
                            }, response => {
                                Serenity.SubDialogHelper.triggerDataChange(self);
                                self.dialogClose();
                                window.setTimeout(() => //Q.notifySuccess(Q.text('Deleted successfully')), 0);
                                    Swal.fire({
                                        icon: 'success',
                                        title: 'Deleted!',
                                        text: 'Item Deleted',
                                        showConfirmButton: false,
                                        timer: 1500
                                    })
                                );
                            }
                        );
                    }
                })
            }

        }

        private confirmBeforeE(oldEvt, e) {
            let self = this;

            var criteria: any;
            var BOMRow: OMS.ProductBOMRow;
            var StockRow: Stock.StockItemRow;
            OMS.ProductBOMService.List({
                Criteria: Serenity.Criteria.and(criteria, [[OMS.ProductBOMRow.Fields.BOMProductId], '=', this.entityId])
            }, response => BOMRow = response.Entities[0], { async: false });

            if (BOMRow == null)
                Stock.StockItemService.List({
                    Criteria: Serenity.Criteria.and(criteria, [[Stock.StockItemRow.Fields.ProductId], '=', this.entityId])
                }, response => StockRow = response.Entities[0], { async: false });

            if (BOMRow != null && StockRow != null) {
                Q.alert("This Material is already in use in Product, Can not delete");
                return;

            }
            else {

                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.isConfirmed) {
                        RawMaterialMasterService.Delete(
                            {
                                EntityId: this.entityId
                            }, response => {
                                Serenity.SubDialogHelper.triggerDataChange(self);
                                self.dialogClose();
                                window.setTimeout(() => //Q.notifySuccess(Q.text('Deleted successfully')), 0);
                                    Swal.fire({
                                        icon: 'success',
                                        title: 'Deleted!',
                                        text: 'Item Deleted',
                                        showConfirmButton: false,
                                        timer: 1500
                                    })
                                );
                            }
                        );
                    }
                })
            }

        }

        //protected updateInterface() {
        //    super.updateInterface();
        //    this.cloneButton.toggle(this.isEditMode());
        //    //this.setReadOnly(this.isViewMode());
        //    this.setReadOnly(this.isViewMode());
        //}

    }
}